module.exports = __webpack_public_path__ + "media/B66.af64b72f.mp3";